import { paths } from "helpers/paths";
import { useEffect } from "react";

const ForwardingAuth = () => {
    useEffect(() => {
        location.replace(
            `${paths.forwardingLogin}?serverKey=${window.location.hostname}&token=${localStorage.getItem("token")}`,
        );
    }, []);
    return null;
};

export default ForwardingAuth;
